__turbopack_context__.v({
  "button": "NavBarOrderTimeSwitchButton-module-scss-module__sksoNG__button",
  "disabled": "NavBarOrderTimeSwitchButton-module-scss-module__sksoNG__disabled",
  "inNavBar": "NavBarOrderTimeSwitchButton-module-scss-module__sksoNG__inNavBar",
  "olandschokladApp": "NavBarOrderTimeSwitchButton-module-scss-module__sksoNG__olandschokladApp",
  "selected": "NavBarOrderTimeSwitchButton-module-scss-module__sksoNG__selected",
  "serviceTimeData": "NavBarOrderTimeSwitchButton-module-scss-module__sksoNG__serviceTimeData",
});
